import { render, staticRenderFns } from "./ProfileModuleSkeleton.vue?vue&type=template&id=45d6df30&scoped=true&"
import script from "./ProfileModuleSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProfileModuleSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ProfileModuleSkeleton.vue?vue&type=style&index=0&id=45d6df30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d6df30",
  null
  
)

export default component.exports